import { useEffect } from 'react'
import { isSameDay } from 'date-fns'
import { useSearchParams } from 'react-router-dom'

import { useDateStore } from '@/components/DateInput'

import tableStyles from '@/ui/Table/ui/Table.module.scss'

export const useShowSharedDisruption = (isLoading: boolean) => {
    const [searchParams] = useSearchParams()
    const sharedDisruptionId = searchParams.get('id')

    const { date, setDate } = useDateStore()

    useEffect(() => {
        const sharedDate = searchParams.get('date')

        if (sharedDate && !isSameDay(new Date(sharedDate), date)) {
            setDate(new Date(sharedDate))
        }

        if (isLoading || !sharedDate) {
            return
        }

        const disruptionEl = document.querySelector<HTMLTableRowElement>(
            `tr[data-disruption-id="${sharedDisruptionId}"]`
        )

        requestAnimationFrame(() => {
            if (disruptionEl) {
                disruptionEl.scrollIntoView({ behavior: 'smooth', block: 'center' })
                disruptionEl.classList.add(tableStyles.selectedRow)
            }
        })
    }, [isLoading, sharedDisruptionId])

    return {
        sharedDisruptionId,
    }
}
